
import { Component, Prop, Vue } from "vue-property-decorator";
import dayjs from "dayjs"
import {
  TelemetryEntry,
  TelemetryEntryValueInterface,
  TelemetryStatus,
} from "@/store-services/telemetry.types";
import { TelemetryTileConfigInterface } from "./telemetry.types";

function formatDateMCC(value: dayjs.Dayjs) {
  return `${value.dayOfYear().toString().padStart(3, "0")}:${value.format("HH:mm:ss")}`
}

function formatDuration(value: number) {
  let duration: {
    calc: number,
    hours: string,
    minutes: string,
    seconds: string
  } = {calc: 0, hours: "", minutes: "", seconds: ""};
  duration.calc = Number((value / 1000).toFixed(0));
  duration.hours = (duration.calc / 3600).toString().split(".")[0].padStart(2, "0");
  duration.calc -= Number(duration.hours) * 3600;
  duration.minutes = (duration.calc / 60).toString().split(".")[0].padStart(2, "0");
  duration.calc -= Number(duration.minutes) * 60;
  duration.seconds = duration.calc.toString().padStart(2, "0");

  return `${duration.hours}:${duration.minutes}:${duration.seconds}`;
}

@Component
export default class TelemetryComponent extends Vue {
  @Prop() config!: TelemetryTileConfigInterface;
  
  get telemetryData(): Array<TelemetryEntry> {
    return this.$store.getters["telemetry/getValue"](this.config.datapoints)
  }
  
  get status(): TelemetryStatus {
    return this.$store.getters["telemetry/getStatus"]();
  }

  get statusStyle() {
    let style: { [key: string]: string } = {
      height: "0.7em",
      color: "#ffffff",
    };
    if (this.status.number < 0) {
      style["color"] = "#009abd"; // blue
    } else if (this.status.number === 24) {
      style["color"] = "#00a400"; // green
    } else {
      style["color"] = "#e60000"; // red
    }

    return style;
  }

  get statusTimeLastString() {
    return formatDateMCC(dayjs(this.status.time.last || 0))
  }

  get statusTimeDelayString() {
    return formatDuration(this.status.time.delay || 0)
  }

  formatValue(value: TelemetryEntryValueInterface) {
    if (value.type === "date") {
      return dayjs.utc(value.value).format("DD.MM.YYYY HH:mm:ss");
    } else if (value.type === "number") {
      return Number(value.value.toFixed(4));
    } else {
      return value.value;
    }
  }
}
